import { Component, OnInit ,ViewChild, AfterViewInit} from '@angular/core';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GridBaseCase } from '../../grid/grid.base.case';
import { MessageclientService } from 'src/service';
import { BaseCase } from 'src/app/basecase';
import { BaseModal } from 'src/model';
import { WebParameterContext } from 'src/model/common';
declare var app;

@Component({
  selector: 'app-viplist',
  templateUrl: './viplist.component.html',
  styleUrls: ['./viplist.component.scss']
})
export class ViplistComponent  extends GridBaseCase implements AfterViewInit{
  dataArrayList: Array<any> = [];
  storeArrayList: Array<any> = [];
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  pageName:string = null;
  searchValue:string = null;//查询内容
  storeId:string = null;//门店id
  roles:string = null;//角色
  selectText:string = null;//选中的门店名字
  initLoadData:boolean = true;//第一次加载数据
  searchPlaceholder:string = null;//搜索框占位符
  isShowSelect:boolean = false;//是否显示下拉框
  isShowSearchInput:boolean = false;//是否显示搜索框
  writeOff:any=60;//会员在60个自然日内产生购买才能核销
  isCancelReceive:boolean = false;//是否取消领店
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    public base:BaseModal
  ) { super();
    this.baseService.FixedSubmitBtn.configName = "Viplist";
    this.baseService.FixedSubmitBtn.isShow = true;
    this.baseService.FixedSubmitBtn.checked = true;
    // this.baseService.FixedSubmitBtn.text = "下一步";
    this.baseService.FixedSubmitBtn.type = 10;
    let that = this;
    that.writeOff = app.writeOff || 60;
    this.pageName = this.activaRouter.snapshot.paramMap.get('ConfigName');
  }
  ngAfterViewInit(){
    console.log("会员列表11");
    let that = this;
    let searchArr = that.com.GetStorageKey("searchArray") || [];
    if(searchArr.length > 0){
      searchArr.forEach(item=>{
        if(item.pageName == that.pageName){
          that.searchValue = item.searchInput;
          // that.storeId = item.selectItem || null;
          // that.selectText = item["selectText"] || "";
        }
      })
    }
  }


  EventLink(event,item){
    let that=this;
    // console.log(item);
    that.com.setHistoryUrl();
    // this.router.navigate([event.url+"getedite/"+item.id.value+"&"+this.com.getNowDatetime]);
     that.com.Go(event.url +item.id+"&"+ that.com.getNowDatetime);
  }

  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.dataArrayList.length) {
      if( that.infiniteScroll){
        that.infiniteScroll.disabled = true;
      }
    } else {
      that.PageNumber++;
      this.LoadDataInfo(that.PageNumber);
    }
  }
  
  LoadDataInfo(PageNumber){
    let that = this;
    // console.log("1008611");
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    // console.log(that.element);
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let id = that.activaRouter.snapshot.paramMap.get('id');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    }else{
      that.msg.Alert("服务端数据配置有误,请联系管理员");
      return;
    }
    // body.ConfigName="MemberManage";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    body.RequestBody = {};
    if(that.searchValue){
      body.RequestBody["b_TelPhone"] = that.com.LikeSearch(that.searchValue.trim());
    }

    const _searchObj = {
      pageName:PageName,
      searchInput:that.searchValue,
      // selectItem:that.storeId,
      // selectText:that.selectText
    };
    that.com.SaveSearchInfo(_searchObj);
    
    body.RequestBody = JSON.stringify(body.RequestBody);
    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页begin****/
      if(PageNumber == 1){
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      }else{
        if( that.infiniteScroll){
          that.infiniteScroll.complete();
        }
       
      }
      console.log(10086);
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          let arrType=[];
          objfield["checked"]=false;
          that.element.selectItemList.selectItem.forEach((element, index) => {
            if (element.bindingField) {
              objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
            }
            if(element.formatter && element.formatter == "Date"){
              if(objfield[element.bindingField].value){
                objfield[element.bindingField].value = objfield[element.bindingField].value.toString().replace(/-/g,"/").replace("T"," ");
              }
            }
            if(element.bindingField == 'deadline' && objfield[element.bindingField] && objfield[element.bindingField].value){
              let _time = objfield[element.bindingField].value.replace(/-/g,"/").replace("T"," ");
              
              let _date = new Date(_time).getTime() + parseInt(that.writeOff) * 24 * 60 * 60 * 1000;
              let _newDate = new Date(_date);
              objfield[element.bindingField].value = _newDate;
            }

            if(objfield["phone"] && objfield["phone"].value){
              objfield["mobile"]={};
              
              objfield["mobile"].value=objfield["phone"].value;
            }
            if(objfield["name"] && objfield["name"].value){
              objfield["name"].value=objfield["name"].value;
            }
           
            // console.log(objfield["modifytime"].value,"&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&");
        
            // that.com.CustomerTag(element,objfield,arrType);//获取所有标签
            if(element.formatter && element.formatter == "type" && element.bindingField=="typeall"){
              if(objfield["type2"].value||objfield["type3"].value||objfield["type4"].value || objfield["type4"].value || objfield["type6"].value || objfield["type7"].value||  objfield["type8"].value)
              {
                if(objfield["type2"]&&objfield["type2"].value)
                {
                  arrType.push(objfield["type2"].text);
                }
                if(objfield["type3"]&&objfield["type3"].value)
                {
                  if(arrType.indexOf(objfield["type2"].text)==-1)
                  {
                  arrType.push(objfield["type2"].text);
                }
                }
                if(objfield["type4"]&&objfield["type4"].value)
                {
                  arrType.push(objfield["type4"].text);
                }
                if(objfield["type6"]&&objfield["type6"].value)
                {
                  arrType.push(objfield["type6"].text);
                }
                if(objfield["type7"]&&objfield["type7"].value)
                {
                  arrType.push(objfield["type7"].text);
                }
                if(objfield["type8"]&&objfield["type8"].value)
                {
                  arrType.push(objfield["type8"].text);
                }
               
              }else
              {
                arrType.push(objfield["type1"].text);
              }
            objfield["typeall"] = { "value": arrType, "text": "新客标签"};
          }
          });
          // objfield["typeall"] = { "value": arrType, "text": "新客标签"};
          that.dataArrayList.push(objfield);
          // that.dataArrayList.push(objfield);
        });
         console.log(that.dataArrayList,"数据1");
        //  that.dataArrayList[0].isAuth.value = true;
         that.dataArrayList.forEach(item=>{
            if( item.createtime && item.createtime.value){
              item.createtime.value=item.createtime.value.replace(/-/g,"/").replace("T"," ");
            }
            if(item.modifytime &&item.modifytime.value){
              item.modifytime.value=item.modifytime.value.replace(/-/g,"/").replace("T"," ");
            }
            if(item.mobile && item.mobile.value){
              let isreplace:boolean;
              isreplace= !item.isAuth.value;
              item.mobile.value= that.com.PhoneNum(item.mobile.value,isreplace);
            }
            if(item.name && item.name.value){
              let isreplace:boolean;
              isreplace= !item.isAuth.value;
              item.name.value= that.com.FormatName(item.name.value,isreplace);
            }
         })

        /****上拉加载数据begin****/
        console.log("会员列表",that.dataArrayList);

        that.RecordCount = data.Status.RecordCount;
        if(that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length){
          // that.infiniteScroll.disabled = true;
          if( that.infiniteScroll){
            that.infiniteScroll.disabled = true;
          }
        }else{
          if( that.infiniteScroll){
            that.infiniteScroll.disabled = false;
          }
        }
        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
 }
 /**
  * 跳转详细页面
  * @param element 
  * @param item 
  */
 EventClick(element,item){
   const that=this;
   if(element.url){
     that.BondInfo(item,element.url);
    }
 }
 BondInfo(item:any,backUrl:any){
   const that=this;
   let items:any={};
   console.log(item)
   items.id={"value":item.id.value,"text":item.id.text};
   items.name={"value":item.name.value,"text":item.name.text};
   items.wechatnickname={"value":item.wechatnickname.value,"text":item.wechatnickname.text};
   items.phone={"value":item.phone.value,"text":item.phone.text};
   items["a_TelPhone"]={"value":item.phone.value,"text":item.phone.text};
   items.createtime={"value":item.createtime.value,"text":item.createtime.text};

   items.IsRepurchaseAuthority={"value":"","text":"是否复购"}; // 是否复购
   items.results={"value":[],"text":"勾选限制字段"}; //  勾选销量弹窗
   items.errorMessage={"value":[],"text":'文字提示'}; // 勾选销量文字提示
   items.typeall={"value":[],"text":"新客标签"};
   items.type1={"value":item.type1.value,"text":item.type1.text};
   items.type2={"value":item.type2.value,"text":item.type2.text};
   items.type3={"value":item.type3.value,"text":item.type3.text};
   items.type4={"value":item.type4.value,"text":item.type4.text};
   items.type5={"value":item.type5.value,"text":item.type5.text};
   items.type6={"value":item.type6.value,"text":item.type6.text};
   items.type7={"value":item.type7.value,"text":item.type7.text};
   items.type8={"value":item.type8.value,"text":item.type8.text};
  console.log(items);
   let body = new WebParameterContext();
   body.Account = that.com.GetAccount;
   body.ConfigName ="MembersInfoManagementXML";
   body.OpType = "query";
   body.ConfigType = "Form";
   body.RowsPerPage = app.RowsPerPage;
   body.PageNumber = 0;
   body.Client.PageName = "WCustomer";
   body.Client.ApiType = "Element";
   body.Client.Name = that.element.name;
   body.Client.ClientType = 2;
   body.SpecialParameter="MemberScanInfo";
   body.RequestBody = {};
   body.RequestBody = JSON.stringify({"a_TelPhone":item.phone.value});
      that.msg.Loading("加载中，请稍后...",).then(load=>{
        that.http.post(app.DEFAULTURL, body).then(data => {
          // debugger;
          load.dismiss();
           if(data.ResponseMessage.Success){
              console.log("删除成功");
              if(data.Status.Datas.length>0){
                console.log()
                let info:any=data.Status.Datas[0]||{};
                console.log(info,"时间数据时间数据时间数据*********");
                items.id.value=info.ID;
                items.wechatnickname.value=info.WeChatNickName;//微信昵称
                items.phone.value=item.mobile.value;//会员手机
                // items.a_TelPhone = item.phone.value
                // item.name.value=info.ChineseName;//会员姓名
                items.createtime.value = info.Register_time.replace(/-/g,"/").replace("T"," ");//注册时间
                // item.aa=info.WeChat_ID;//IsMembersMama:妈妈奶粉会员；IsMembersS3：S3会员；IsMembersIMF：忠实会员；IsPureMember：普通会员 IfS4：四段会员
                items.typeall.value=[];
                items.type1.value=info.IsPureMember;
                items.type2.value=info.IsMembersIMF;
                items.type3.value=info.IsMembersMama;
                items.type4.value=info.IsMembersS3;
                items.type5.value=info.IsTePei;
                items.type6.value=info.IsMemberS4;
                items.type7.value=info.IsMemberS4_PT;
                items.type8.value=info.IsMemberS4_HA;
                items.IsRepurchaseAuthority = info.IsRepurchaseAuthority;
                items.results =info.results;
                items.errorMessage =info.errorMessage;
                if(info.IsPureMember){
                  items.typeall.value.push("普通会员");
                }
                if(info.IsMembersMama){
                  items.typeall.value.push("妈妈奶粉会员");
                }
                if(info.IsMembersIMF){
                  items.typeall.value.push("忠实会员");
                }
                if(info.IsMembersS3){
                  // items.typeall.value.push("S3会员");
                  items.typeall.value.push("幼儿新客");
                }
                if(info.IsTePei){
                  items.typeall.value.push("守护计划");
                }
                if(info.IsMemberS4){
                  items.typeall.value.push("四段会员");
                }
                if(info.IsMemberS4_PT){
                  items.typeall.value.push("四段会员-瑞铂");
                }
                if(info.IsMemberS4_HA){
                  items.typeall.value.push("四段会员-超启");
                }
                items.typeinfoType=false;//判断是否选择礼品
                if(info.CanBeLoyalMember){
                  items.typeinfoType=true;
                }
                if(info.CanBeMMP){
                  items.typeinfoType=true;
                }
                if(info.CanBeS3){
                  items.typeinfoType=true;
                }
              }
             
              that.com.setHistoryUrl(false);
              that.com.removeItem(["homing","product","meminfo","activityName"]);
              localStorage.setItem("meminfo",JSON.stringify(items));
              console.log("会员对象",items);
              that.com.Go(backUrl+item.id.value + "&" + that.com.getNowDatetime);
           }else{
             that.msg.Alert(data.ResponseMessage.ErrorMessage);
           }
         }).catch(res=>{
          load.dismiss();
          that.msg.Alert(app.ERRORMESSAGE);
         })
         load.present();
      });
 }

   /**
   * 搜索事件
   * @param e 
   */
  serarEvent(e,type:string = 'type'){ 
    if(e.keyCode == 13 || type=='search'){
      this.LoadDataInfo(1);
    }
  }

  LoadData(PageNumber){
    this.LoadDataInfo(PageNumber);
  }
  /**
   * 删除操作
   */
  EventClickCehcked(){
    let that = this;
     console.log("删除");
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let id = that.activaRouter.snapshot.paramMap.get('id');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName ="TBMemberScanXML";
    // body.ConfigName="MemberManage";
    body.OpType = "delete";
    body.ConfigType = "form";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 0;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    body.RequestBody = {};
    let _tempArray:Array<any> = new Array<any>();
    that.dataArrayList.forEach(item=>{
      if(item.checked){
        _tempArray.push(item.fid.value);
      }
    });
    if(_tempArray.length<=0){
        that.msg.Alert("请先选择需要删除的数据");
        return;
    }
    that.msg.Confirm("确认删除吗?","取消","确定").then(res=>{
        if(res){
          body.RequestBody = JSON.stringify({"a_ID":_tempArray});
          that.http.post(app.DEFAULTURL, body).then(data => {
            if(data.ResponseMessage.Success){
              that.baseService.FixedSubmitBtn["isCheckAll"]=false;
              that.LoadData(1);
               console.log("删除成功");
            }else{
              that.msg.Alert(data.ResponseMessage.ErrorMessage);
            }
          });
        }
    });
  }
  //确定按钮
  EventSure(){
    const that=this;
    that.dataArrayList.forEach(item=>{
      item.checked=that.baseService.FixedSubmitBtn["isCheckAll"];
    });
    console.log( that.baseService.FixedSubmitBtn["isCheckAll"] );
      console.log("全选")
  }
  onInput(item,e){
    console.log("选中");
    const that=this;
    item.checked=e.target.checked;
    if(!e.target.checked){
      that.baseService.FixedSubmitBtn["isCheckAll"]=false;//全选问题
    }else{
      let istrue:boolean=true;//表示全选
      that.dataArrayList.forEach(items=>{
        if(!items.checked){
          istrue=false;
        }
      });
      if(istrue){
        that.baseService.FixedSubmitBtn["isCheckAll"]=true;
      }
    }
   
  }
}
